import NewTeamReport from './new/NewTeamReportContainer';
import TeamReportDetails from './details/TeamReportDetails';
import TeamReportListContainer from './TeamReportListContainer';

const TeamReportRoutes = [
  { path: '/accounts/:aid/team-reports/', component: TeamReportListContainer, exact: true },
  { path: '/accounts/:aid/team-reports/new', component: NewTeamReport },
  { path: '/accounts/:aid/team-reports/:reportId', component: TeamReportDetails },
];

export default TeamReportRoutes;
